<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="8px">
  <mat-progress-bar mode="buffer" [value]="progress$ | async" />
  <div class="mat-caption">Uploading Video</div>
</div>
